// Right after signing in, make sure the user has a profile: a new user gets a
// blank one and is taken to fill it in. Runs once per sign-in (completeSignIn
// leaves the flag), and renders nothing.
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { displayEmail, useSession } from "@jkast90/kast-common/auth";
import { profilesApi } from "../../_common/services/kindlyApi";
import { session } from "../session";
import { JUST_SIGNED_IN_KEY } from "../signIn";

/** Creates the profile if there is none; true when it did. */
async function ensureProfile(email: string): Promise<boolean> {
  try {
    await profilesApi.getByEmail(email);
    return false;
  } catch (error) {
    const message = error instanceof Error ? error.message : "";
    if (!message.includes("404") && !message.includes("Profile not found")) {
      console.error("[Auth] Error checking profile:", error);
      return false;
    }
    await profilesApi.create({ email, first_name: "", last_name: "" });
    return true;
  }
}

export default function FirstSignIn() {
  const navigate = useNavigate();
  const { status, user } = useSession(session);
  const email = displayEmail(user);

  useEffect(() => {
    if (status !== "signedIn" || !email) return;
    try {
      const justSignedIn = sessionStorage.getItem(JUST_SIGNED_IN_KEY) !== null;
      sessionStorage.removeItem(JUST_SIGNED_IN_KEY);
      if (!justSignedIn) return;
    } catch {
      return;
    }
    ensureProfile(email).then(
      (created) => {
        if (created) navigate("/profile?edit=true", { replace: true });
      },
      (error) => console.error("[Auth] Could not create the profile:", error),
    );
  }, [status, email, navigate]);

  return null;
}
